<template>
  <div class="home d-flex flex-column">
    <div class="banner">
      <img src="@/assets/logo.png" width="250" height="250" alt="Lyt-Soft Logo">
    </div>
    <LoginForm/>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginForm from '@/components/LoginForm.vue'

export default {
  name: 'LoginView',
  components: { LoginForm }
}
</script>
<style scoped lang="scss">
.home{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

</style>
